export const SearchSkeleton = () => {
  const cards = (
    <div className="flex flex-col gap-4 md:flex-row">
      <div className="h-[400px] w-full animate-pulse rounded-2xl  bg-gray-300 py-8"></div>
      <div className="h-[400px] w-full animate-pulse rounded-2xl bg-gray-300 py-8"></div>
    </div>
  );

  return (
    <div className={`col-span-12 grid  animate-pulse gap-4`}>
      {cards}

      {cards}

      {cards}
    </div>
  );
};
